module.exports = __webpack_public_path__ + "static/img/S7.0c883ed3.png";